import { c as _c } from "react/compiler-runtime";
import { ChipStatus, NO_TRANSLATE_CLASS, Text } from "@flat-ui";
import { Stack } from "@mui-wrapper";
import { getMarkupStatusLabel } from "@pages/project-details/project-markups/status/markup-status-utils";
import { useState } from "react";
/** Column of the board with the markups of a status, where markups of other statuses can be dropped */
export function ProjectMarkupsBoardColumn(t0) {
  const $ = _c(32);
  const {
    status,
    count,
    canDrop,
    onDrop,
    children
  } = t0;
  const [isDragOver, setIsDragOver] = useState(false);
  let t1;
  if ($[0] !== canDrop) {
    t1 = function handleDragOver(event) {
      if (!canDrop) {
        return;
      }
      event.preventDefault();
      event.dataTransfer.dropEffect = "move";
      setIsDragOver(true);
    };
    $[0] = canDrop;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleDragOver = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = function handleDragLeave(event_0) {
      if (!(event_0.relatedTarget instanceof Node) || !event_0.currentTarget.contains(event_0.relatedTarget)) {
        setIsDragOver(false);
      }
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleDragLeave = t2;
  let t3;
  if ($[3] !== onDrop || $[4] !== status) {
    t3 = function handleDrop(event_1) {
      event_1.preventDefault();
      setIsDragOver(false);
      onDrop(status);
    };
    $[3] = onDrop;
    $[4] = status;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleDrop = t3;
  let t4;
  if ($[6] !== status) {
    t4 = getMarkupStatusLabel(status);
    $[6] = status;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== canDrop || $[9] !== isDragOver) {
    t5 = isDragOver && canDrop && {
      outlineColor: "primary.main",
      backgroundColor: "action.hover"
    };
    $[8] = canDrop;
    $[9] = isDragOver;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = {
      flex: "1 0 15rem",
      minWidth: "15rem",
      borderRadius: 1,
      backgroundColor: "surfaces.secondary",
      outline: "2px dashed transparent",
      outlineOffset: "-2px",
      ...t5
    };
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      alignItems: "center",
      gap: 1,
      p: 1.5,
      position: "sticky",
      top: 0,
      zIndex: 1,
      borderRadius: 1,
      backgroundColor: "surfaces.secondary"
    };
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== status) {
    t8 = <ChipStatus status={status} size="small" />;
    $[14] = status;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      color: "text.secondary"
    };
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== count) {
    t10 = <Text variant="bodyS" className={NO_TRANSLATE_CLASS} sx={t9}>{count}</Text>;
    $[17] = count;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t8) {
    t11 = <Stack direction="row" sx={t7}>{t8}{t10}</Stack>;
    $[19] = t10;
    $[20] = t8;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      gap: 1,
      px: 1,
      pb: 1
    };
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== children) {
    t13 = <Stack sx={t12}>{children}</Stack>;
    $[23] = children;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== handleDragOver || $[26] !== handleDrop || $[27] !== t11 || $[28] !== t13 || $[29] !== t4 || $[30] !== t6) {
    t14 = <Stack component="section" aria-label={t4} onDragOver={handleDragOver} onDragLeave={handleDragLeave} onDrop={handleDrop} sx={t6}>{t11}{t13}</Stack>;
    $[25] = handleDragOver;
    $[26] = handleDrop;
    $[27] = t11;
    $[28] = t13;
    $[29] = t4;
    $[30] = t6;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  return t14;
}